import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../../lib/api/client';
import { authQueryKeys } from '../../lib/api/auth';

export function LoginScreen() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await adminApi.post('/auth/login', { email, password });
      await qc.invalidateQueries({ queryKey: authQueryKeys.me });
      await navigate({ to: '/' });
    } catch {
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--lca-paper)' }}>
      <form onSubmit={handleSubmit} style={{ width: 360, padding: 32, borderRadius: 16, background: 'var(--lca-surface)', boxShadow: '0 0 0 1px var(--lca-hairline), 0 4px 24px rgba(10,14,20,0.08)' }}>
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontFamily: 'var(--lca-font-display)', fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em', color: 'var(--lca-ink)' }}>Admin</div>
          <div style={{ fontSize: 13, color: 'var(--lca-gray-500)', marginTop: 4 }}>Sign in to ChatTrust.AI Administration</div>
        </div>
        {error && <div style={{ marginBottom: 16, padding: '10px 14px', borderRadius: 8, background: 'rgba(220,50,50,0.08)', color: 'var(--lca-red)', fontSize: 13 }}>{error}</div>}
        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: 'var(--lca-gray-700)', marginBottom: 6 }}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
            style={{ width: '100%', boxSizing: 'border-box', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--lca-hairline)', background: 'var(--lca-paper)', color: 'var(--lca-ink)', fontSize: 14, outline: 'none' }} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: 'var(--lca-gray-700)', marginBottom: 6 }}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
            style={{ width: '100%', boxSizing: 'border-box', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--lca-hairline)', background: 'var(--lca-paper)', color: 'var(--lca-ink)', fontSize: 14, outline: 'none' }} />
        </div>
        <button type="submit" disabled={loading}
          style={{ width: '100%', padding: '10px', borderRadius: 8, border: 'none', background: 'var(--lca-ink)', color: 'var(--lca-paper)', fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
